module.exports = __webpack_public_path__ + "static/logo-a6d1658823c213d2a661c764c67b8f62.png";